import React, { useState, useEffect, useContext, useMemo } from "react";
import { IconButton, Badge } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import dayjs from "dayjs";
import { NotificationContext } from "../../App";
import NotificationList from "./AppBarNotificationList";
import { useInterval } from "ahooks";
import { updateNotificationAPI } from "@/apis/updateNotificationAPI";
import { getNotificationList } from "@/reducers/getNotificationReducer";
import TermDialog from "./TermDialog";

const NotificationIconBtn = () => {
  const { get } = useContext(NotificationContext);
  const [notiDetailDialogOpen, setNotiDetailDialogOpen] = useState(false);
  const [notiItems, setNotiItems] = useState([]);
  const [currentNotiItems, setCurrentNotiItems] = useState("");
  const [anchorNotiEl, setAnchorNotiEl] = useState(null); // Noti menu pop out position
  const [hasConfirmBtn, setHasConfirmBtn] = useState(false)
  const isMenuNotiOpen = Boolean(anchorNotiEl);

  const notificationList = useMemo(() => {
    return notiItems.filter(item => {
      const nInfo = item.json || {};
      const now = dayjs();
      const startTime = dayjs(Number(item.createdAt));
      const endTime = dayjs(Number(nInfo.endTime));
      if (!nInfo.endTime || String(nInfo.endTime) === "0") {
        return true;
      }

      return now.isBetween(startTime, endTime);
    });
  }, [notiItems]);

  const setNotificationList = async () => {
    const hasNotifications = await getNotificationList();
    if (hasNotifications) {
      const notiItems = hasNotifications.notificationListObjArr.map(obj => ({
        ...obj,
        read: false
      }));
      setNotiItems(notiItems);
    }
  };

  useInterval(() => {
    setNotificationList();
  }, 60000);

  const handleNotificationMenuOpen = event => {
    setAnchorNotiEl(event.currentTarget);
  };

  const handleNotificationMenuClose = () => {
    setAnchorNotiEl(null);
  };

  const handleNotificationDialogOpen = async notiItem => {
    setHasConfirmBtn(false)
    setNotiDetailDialogOpen(true);
    handleNotificationMenuClose();
    setCurrentNotiItems(notiItem);
    //update one single notification api
    const notificationIdsArr = [notiItem.id];
    await updateNotificationAPI(notificationIdsArr);

    setNotificationList();
  };

  const handleNotificationDialogClose = (needRefreshData) => {
    setHasConfirmBtn(false);
    setNotiDetailDialogOpen(false);
    if (needRefreshData) setNotificationList();
  };

  useEffect(() => {
    const lastLoginTime = localStorage.getItem('lastLoginTime')
    const lastLoginPopupTime = localStorage.getItem('lastLoginPopupTime')
    if (lastLoginTime && ((Date.now() - parseInt(lastLoginTime)) < 15000) && (lastLoginPopupTime !== lastLoginTime)) {
      getNotificationList().then(({notificationListObjArr: notis}) => {
        const lastPopup = notis.filter(item => item.json?.popup && !(Number(item.readAt) >= 0)).filter(item => {
          const nInfo = item.json || {};
          const now = dayjs();
          const startTime = dayjs(Number(item.createdAt));
          const endTime = dayjs(Number(nInfo.endTime));
          if (!nInfo.endTime || String(nInfo.endTime) === "0") {
            return true;
          }
    
          return now.isBetween(startTime, endTime);
        }).sort(
          (a, b) => Number(b.createdAt) - Number(a.createdAt)
        )?.[0];
        // 检查弹窗有的话就弹
        if (lastPopup) {
          localStorage.setItem('lastLoginPopupTime', lastLoginTime)
          setHasConfirmBtn(true)
          setNotiDetailDialogOpen(true);
          setCurrentNotiItems(lastPopup)
        }
      });
    }
  }, [])

  useEffect(() => {
    if (!notiDetailDialogOpen || get) setNotificationList();
  }, [notiDetailDialogOpen, get]);

  useEffect(() => {
    if (window.__diyFunction__setAnnouncement) {
      const lastNotification = notificationList?.filter(v => !v.readAt || Number(v.readAt)<0).sort(
        (a, b) => Number(b.createdAt) - Number(a.createdAt)
      )?.[0];
      if (lastNotification) {
        window.__diyFunction__announcement_notificationId = lastNotification?.id; 
        window.__diyFunction__announcement_refresh = setNotificationList;
        window.__diyFunction__announcement = lastNotification?.json || null;
        window.__diyFunction__setAnnouncement(lastNotification?.json || null);
      } else {
        window.__diyFunction__announcement = null;
        window.__diyFunction__setAnnouncement(null);
      }
    }
  }, [notificationList]);

  return (
    <>
      <IconButton
        aria-label="Notifications"
        color="inherit"
        onClick={handleNotificationMenuOpen}
      >
        <Badge
          color="error"
          overlap="rectangular"
          badgeContent={
            notiItems.filter(item => Number(item.readAt) < 0).length
          }
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationList
        open={isMenuNotiOpen}
        onClose={handleNotificationMenuClose}
        anchorEl={anchorNotiEl}
        notiItems={notiItems}
        currentNotiItem={currentNotiItems}
        hasConfirmBtn={hasConfirmBtn}
        notiDetailDialogOpen={notiDetailDialogOpen}
        handleNotificationDialogOpen={handleNotificationDialogOpen}
        handleNotificationDialogClose={handleNotificationDialogClose}
        handleNotificationMenuClose={handleNotificationMenuClose}
      />
      <TermDialog />
    </>
  );
};

export default NotificationIconBtn;
